if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
           
            document.body.classList.remove('variant_popup_active');
            document.querySelectorAll('variant-popup').forEach(function(evt){
              evt.classList.remove('pop_the_variant')
            })

  let button = document.querySelector('.OffersAvailable .Offerstxtie ');
            var buttons = document.querySelectorAll(".buttonAvilable");
let addoff = document.querySelector('.InnerOfferAvailable');
let drawerOuter = document.querySelector('.drawer__footer');
let drawersummary = document.querySelector('.InnerPrice_Summary .summary__title');
let crossbutton = document.querySelector('.CrossICon');
let summarycross = document.querySelector('.Caret .CrossSlide_arrow');
let summary = document.querySelector('.MainPrice_Summary');

  button.addEventListener('click', function() {
    addoff.classList.add('offeractive');
    drawerOuter.classList.add('Clickoffer');
     document.body.classList.add("DrawerAccordion");
    summary.removeAttribute('open');
  });
  crossbutton.addEventListener('click', function() {
    addoff.classList.remove('offeractive');
      document.body.classList.remove("DrawerAccordion");
     drawerOuter.classList.remove('Clickoffer');
  });

// Loop through each button
buttons.forEach(function(button) {
    // Add a click event listener to each button
    button.addEventListener("click", function() {
        // Find the parent element with class "FirstOffer_Start"
        var mainContainerCart = button.closest(".FirstOffer_Start");
        
        // Find the element with class "FirstOffer_content" within the parent element
        var firstOfferContent = mainContainerCart.querySelector(".FirstOffer_content");
        
        // Toggle the visibility of the "FirstOffer_content" element
        if (firstOfferContent.style.display === "none" || !firstOfferContent.style.display) {
            firstOfferContent.style.display = "block";
        } else {
            firstOfferContent.style.display = "none";
        }
    });
});            

  drawersummary.addEventListener('click', function() {
    drawerOuter.classList.add('SummaryOffers');
     document.body.classList.add("DrawerAccordion");
  });

 summarycross.addEventListener('click', function() {
      document.body.classList.remove("DrawerAccordion");
  });

            function copyToClipboard(textSelector) {
  const textToCopy = document.querySelector(textSelector);
  const selection = window.getSelection();
  const range = document.createRange();
  
  range.selectNodeContents(textToCopy);
  selection.removeAllRanges();
  selection.addRange(range);
  
  document.execCommand('copy');
  selection.removeAllRanges();

  document.execCommand('copy');
    selection.removeAllRanges();
    const applyDiv = document.querySelector('.applyDiv');
    applyDiv.querySelector('#copyButtonText p').innerHTML = 'Copied';
    setTimeout(function(){
      applyDiv.querySelector('#copyButtonText p').innerHTML = 'Copy'
    },2000);    
  }

if( document.querySelector('.cp1') ){
  document.querySelector('.cp1').addEventListener('click', function() {
    copyToClipboard('.OfferCode p');
  });
  };

  if( document.querySelector('.cp2') ){
  document.querySelector('.cp2').addEventListener('click', function() {
    copyToClipboard('.OfferCode p');
  });
      };


if(  document.querySelector('#copyButtonText') ){
document.querySelector('#copyButtonText').addEventListener('click', function() {
    copyToClipboard('#textToCopy p');
  });
}
    




            
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
